window.stopPropagation = function stopPropagation(event){
	if (event.stopPropagation)
		event.stopPropagation();
	else if (window.event) // this code is for IE
		window.event.cancelBubble = true;
}

window.detectDevice = function detectDevice () {
	var width = (window.innerWidth > 0) ? window.innerWidth : screen.width;
	if (width <= 568) {
		return "mobile";
	} else if (width <= 768){
		return "pad";
	} else {
		return "desktop";
	}
}

window.initCommonVar = function initCommonVar()
{
	window.gVar.stockNm		= "";	//for track queue

	window.gVar.trackStockNum	= 10;
	window.gVar.trackGroupNum	= 5;

	window.gVar.socket			= null;
	window.gVar.rooms			= [];
}

window.jumpToPage = function jumpToPage(isNewWindow)
{
	var pathnameSplitArray = window.location.pathname.split('/')
	var isAnalysisPage = pathnameSplitArray[1] === 'analysis'
	var url = "/analysis/" + encodeURIComponent($("input[name='stockid']").val().split(' ')[0]);
	if (isAnalysisPage) {
		var indicator = pathnameSplitArray[3]
		url = url + '/' + indicator
	}
	if (isNewWindow) {
		window.open(url);
	} else {
		location = url;
	}
}

/* browser check */
window.browserIECheck = function browserIECheck()
{
	if (!getCookie('upgrade_browser')) {
		if (navigator.appName == 'Microsoft Internet Explorer') {
			var ua = navigator.userAgent;
			var re  = new RegExp("MSIE ([0-9]{1,}[\.0-9]{0,})");

			if (re.exec(ua) != null) {
				rv = parseFloat( RegExp.$1 );
			}

			if (rv <= 7.0) {
				alert('為了更好的使用者體驗，請使用其他瀏覽器 (ex: Chrome、Firefox) 或最新版的 IE 感謝');
			}
		}
		setCookie('upgrade_browser', 1, 1, '/');
	}
}

/* component handle in mobile */
window.footerInitHandleInMobile = function footerInitHandleInMobile()
{
	$("#footer .section-title").click(function(event){
		var section = $(this).parent();
		if (section.hasClass("is-active")) {
			section.removeClass("is-active");
		} else {
			section.addClass("is-active");
		}
		stopPropagation(event);
	});
}

window.onLoadSetting = function onLoadSetting()
{
	$("#frame, #footer").css("visibility","visible");

	//init bind click func

	$(".sub-menu li").click(function(){
		$(".sub-menu li").removeClass("selected");
		$(this).addClass("selected");
	});

	//check IE version
	browserIECheck();

	//mobile footer
	footerInitHandleInMobile();
}

// implement JSON.stringify serialization
window.jsonStringify = function jsonStringify(obj) {
	var t = typeof (obj);
	if (t != "object" || obj === null) {
		// simple data type
		if (t == "string") obj = '"'+obj+'"';
		return String(obj);
	}
	else {
		// recurse array or object
		var n, v, json = [], arr = (obj && obj.constructor == Array);
		for (n in obj) {
			v = obj[n]; t = typeof(v);
			if (t == "string") v = '"'+v+'"';
			else if (t == "object" && v !== null) v = JSON.stringify(v);
			json.push((arr ? "" : '"' + n + '":') + String(v));
		}
		return (arr ? "[" : "{") + String(json) + (arr ? "]" : "}");
	}
}

// addCommas and toFixed(2)
window.numFormat = function numFormat(nStr)
{
	// Avoid formatting non numeric string such as date string
	if (!$.isNumeric(nStr)) {
		return nStr;
	}

	nStr += "";
	var x = nStr.split(".");
	var x1 = x[0];
	var x2;
	if (x.length > 1) {	// has "."
		while(x[1].length >= 3)
			x[1] = x[1].slice(0,-1);
		x2 = "." + x[1];
	} else {
		x2 = "";
	}

	//x2 = x.length>1 ?("." + x[1]):'';
	var rgx = /(\d+)(\d{3})/;
	while (rgx.test(x1)) {
		x1 = x1.replace(rgx, "$1" + "," + "$2");
	}
	return x1 + x2;
}

window.debug_message = function debug_message(msg)
{
	//if ie
	if (window.ActiveXObject || "ActiveXObject" in window) {
		return;
	}
	if (gVar.debug) {
		console.log(msg);
	}
}

/* common alert windows operation */
/* init thickbox*/
window.initAlertWin = function initAlertWin(obj)
{
	var t = obj.title || obj.name || null;
	var a = obj.href || obj.alt;
	var g = obj.rel || false;
	tb_show(t,a,g);
	obj.blur();

	return false;
}
